exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".flex[data-v-025819b0]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.skin-tabs-view[data-v-025819b0]{height:560px;overflow:auto;padding-right:10px}.skin-view[data-v-025819b0]{max-width:100%;overflow-x:hidden}[data-v-025819b0]:deep(.el-tabs__item){max-width:150px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}", ""]);

// exports
